// Centralized project lists for use across the app
import { ProjectInterface } from '../pages/Projects';
import { projectDetails as PuzzleCave } from './PuzzleCave';
import { projectDetails as IzasSupermarket } from './IzasSupermarket';
import { projectDetails as ElementalBlitz } from './ElementalBlitz';
import { projectDetails as ShepherdFarm } from './ShepherdFarm';
import { projectDetails as Nodebook } from './Nodebook';
import { projectDetails as CheckMore } from '../components/CheckMoreProjects';
import { projectDetails as Asteroids } from './Asteroids';
import { projectDetails as Models } from './Models';
import { projectDetails as MazeDiscover } from './MazeDiscover';
import { projectDetails as GDSTD4 } from './GDSTD4';
import { projectDetails as SpookyIsland } from './SpookyIsland';
import { projectDetails as ProceduralStudy } from './ProceduralStudy';
import { projectDetails as RomanceBrawl } from './RomanceBrawl';
import { projectDetails as Run01 } from './Run01';
import { projectDetails as StreetRacing } from './StreetRacing';
import { projectDetails as GDSTD3 } from './GDSTD3';
import { projectDetails as GDSTD2 } from './GDSTD2';
import { projectDetails as GDSTD1 } from './GDSTD1';
import { projectDetails as WarehouseInvasion } from './WarehouseInvasion';
import { projectDetails as SUB } from './SUB';
import { projectDetails as GenArt } from './GenArt';
import { projectDetails as Drawings } from './Drawings';

export const latestWeb: ProjectInterface[] = [
  IzasSupermarket,
  ElementalBlitz,
  ShepherdFarm,
  // Nodebook,
  PuzzleCave,
  CheckMore
];

export const latestMobile: ProjectInterface[] = [
  IzasSupermarket,
  PuzzleCave,
  ElementalBlitz,
  CheckMore
];

export const allProjects: ProjectInterface[] = [
  PuzzleCave,
  Nodebook,
  ElementalBlitz,
  IzasSupermarket,
  Asteroids,
  Models,
  ShepherdFarm,
  MazeDiscover,
  GDSTD4,
  SpookyIsland,
  ProceduralStudy,
  RomanceBrawl,
  Run01,
  StreetRacing,
  GDSTD3,
  GDSTD2,
  GDSTD1,
  WarehouseInvasion,
  SUB,
  GenArt,
  Drawings
];

export const professionalProjects: ProjectInterface[] = [
  IzasSupermarket,
  ShepherdFarm,
  MazeDiscover,
  SpookyIsland,
];

export const personalProjects: ProjectInterface[] = [
  PuzzleCave,
  ElementalBlitz,
  Asteroids,
  RomanceBrawl,
  Run01,
  StreetRacing,
  WarehouseInvasion,
  SUB,
];

export const sideProjects: ProjectInterface[] = [
  Nodebook,
  GDSTD4,
  ProceduralStudy,
  GDSTD3,
  Models,
  GDSTD2,
  GDSTD1,
  GenArt,
  Drawings
];

// Map project names to their details
const projectMap: Record<string, ProjectInterface> = {
  PuzzleCave,
  IzasSupermarket,
  ElementalBlitz,
  ShepherdFarm,
  Nodebook,
  CheckMore,
  Asteroids,
  Models,
  MazeDiscover,
  GDSTD4,
  SpookyIsland,
  ProceduralStudy,
  RomanceBrawl,
  Run01,
  StreetRacing,
  GDSTD3,
  GDSTD2,
  GDSTD1,
  WarehouseInvasion,
  SUB,
  GenArt,
  Drawings,
};

// Utility function to get projects by name
export function getProjectsByNames(names: string[]): ProjectInterface[] {
  return names
    .map(name => projectMap[name])
    .filter((project): project is ProjectInterface => !!project);
}
